import { computed, inject, onBeforeUnmount, ref } from 'vue';

// Trocar de seção desmonta a anterior, e cada seção guarda o que se edita em refs copiadas do
// agente: a edição sumia calada ao clicar em outra seção, e o Publicar saía sem ela. Com este
// composable a seção diz QUAL é o seu estado e COMO se salva; a página sabe se a seção aberta
// está suja (ponto no trilho, guarda de troca e de saída, ⌘S) sem cada seção reinventar isso.
//
// `estado` devolve o que a pessoa edita (refs lidas, nada de objeto do agente inteiro);
// `definirSalvar(save)` entrega o save da seção (declarado depois, porque ele chama `limpar`),
// que chama `limpar()` quando grava. A guarda pergunta se deu certo
// olhando o próprio estado: continuar suja depois de salvar é ter falhado (o toast já disse por
// quê), e a pessoa fica onde está.
export function useRascunhoDaSecao(estado) {
  const ctx = inject('powerAgentContext', null);
  const foto = () => JSON.stringify(estado());
  const inicial = ref(foto());
  const suja = computed(() => foto() !== inicial.value);

  let salvar = null;
  const registro = {
    suja: () => suja.value,
    salvar: async () => {
      await salvar?.();
      return !suja.value;
    },
  };
  function definirSalvar(fn) {
    salvar = fn;
  }
  ctx?.registrarSecao?.(registro);
  onBeforeUnmount(() => ctx?.soltarSecao?.(registro));

  // Depois de gravar (ou de carregar o que o servidor tem), o que está na tela vira o "limpo".
  function limpar() {
    inicial.value = foto();
  }

  return { suja, limpar, definirSalvar };
}
